// src/frontend/js/modern/shared/constants.js

export const STORAGE_KEYS = {
	WISHLIST: 'wlfmc_modern_wishlist',
	WAITLIST: 'wlfmc_modern_waitlist',
	MULTI_LIST: 'wlfmc_modern_multi_list',
	CONFIG: 'wlfmc_modern_config',
	QUEUE_STATE: 'wlfmc_queue_state',
	SYNC_VERSION: 'wlfmc_sync_version',
	SYNC_DATA: 'wlfmc_sync_data',
	LAST_SYNC: 'wlfmc_last_sync',
	PRODUCTS_HASH: 'wlfmc_products_hash',
	WAITLIST_HASH: 'wlfmc_waitlist_hash',
	LANG_HASH: 'wlfmc_lang_hash',
};

export const EVENTS = {
	WISHLIST_ADDED: 'wishlist:added',
	WISHLIST_REMOVED: 'wishlist:removed',
	WISHLIST_UPDATED: 'wishlist:updated',
	WISHLIST_COUNT_CHANGED: 'wishlist:countChanged',
	WISHLIST_ITEM_UPDATED: 'wishlist:itemUpdated',
	WISHLIST_ITEM_ADDED_TO_CART: 'wishlist:itemAddedToCart',
	WISHLIST_ITEM_ADD_TO_CART_FAILED: 'wishlist:itemAddToCartFailed',

	WAITLIST_ADDED: 'waitlist:added',
	WAITLIST_REMOVED: 'waitlist:removed',
	WAITLIST_UPDATED: 'waitlist:updated',
	WAITLIST_COUNT_CHANGED: 'waitlist:countChanged',

	MULTI_LIST_ADDED: 'multiList:added',
	MULTI_LIST_REMOVED: 'multiList:removed',
	MULTI_LIST_UPDATED: 'multiList:updated',
	MULTI_LIST_COUNT_CHANGED: 'multiList:countChanged',
	MULTI_LIST_CREATED: 'multiList:created',
	MULTI_LIST_DELETED: 'multiList:deleted',
	MULTI_LIST_PRIVACY_CHANGED: 'multiList:privacyChanged',

	SAVE_FOR_LATER_ADDED: 'saveForLater:added',
	SAVE_FOR_LATER_REMOVED: 'saveForLater:removed',
	SAVE_FOR_LATER_UPDATED: 'saveForLater:updated',
	SAVE_FOR_LATER_COUNT_CHANGED: 'saveForLater:countChanged',

	ACTION_STARTED: 'action:started',
	ACTION_COMPLETED: 'action:completed',
	ACTION_FAILED: 'action:failed',
	ACTION_RETRY: 'action:retry',
	ACTION_TIMEOUT: 'action:timeout',
	SYNC_STARTED: 'sync:started',
	SYNC_COMPLETED: 'sync:completed',
	SYNC_FAILED: 'sync:failed',
	STATE_CHANGED: 'state:changed',
	OFFLINE_STATUS_CHANGED: 'offline:statusChanged',
	SYSTEM_READY: 'system:ready',
	UI_REINIT: 'ui:reinit',
	CONTENT_UPDATED: 'content:updated',
};

export const AJAX_ACTIONS = {
	WISHLIST_ADD: 'wlfmc_add_to_wishlist',
	WISHLIST_REMOVE: 'wlfmc_remove_from_wishlist',
	WISHLIST_DELETE_ITEM: 'wlfmc_delete_item',
	WISHLIST_ADD_TO_CART: 'wlfmc_add_to_cart',
	WISHLIST_SORT: 'wlfmc_sort_wishlist_items',
	WISHLIST_UPDATE_QUANTITY: 'wlfmc_update_item_quantity',
	WISHLIST_CHANGE_LAYOUT: 'wlfmc_change_layout',
	WAITLIST_ADD: 'wlfmc_add_product_to_waitlist',
	WAITLIST_REMOVE: 'wlfmc_remove_from_wishlist',
	MULTI_LIST_ADD: 'wlfmc_add_product_to_list',
	MULTI_LIST_REMOVE: 'wlfmc_remove_from_wishlist',
	MULTI_LIST_MOVE: 'wlfmc_move_to_another_list',
	MULTI_LIST_COPY: 'wlfmc_copy_to_list',
	MULTI_LIST_CREATE: 'wlfmc_create_new_list',
	MULTI_LIST_DELETE: 'wlfmc_delete_list',
	MULTI_LIST_UPDATE: 'wlfmc_update_list',
	MULTI_LIST_PRIVACY: 'wlfmc_change_privacy',
	MULTI_LIST_LOAD: 'wlfmc_load_lists',
	SAVE_FOR_LATER_ADD: 'wlfmc_add_to_save_for_later',
	SAVE_FOR_LATER_REMOVE: 'wlfmc_remove_from_save_for_later',
	SAVE_FOR_LATER_ADD_TO_CART: 'wlfmc_save_for_later_add_to_cart',
	SAVE_FOR_LATER_ADD_ALL: 'wlfmc_add_all_to_save_for_later',
	LOAD_AUTOMATIONS: 'wlfmc_load_automations',
	GDPR_ACTION: 'wlfmc_change_gdpr_status',
};
